export const ENGINE_PAYMENT = 64;

export const PAYMENT_PLAN_STATUS_ERROR = 2;

export const PAYMENT_STATUS_PAID = 2;
export const PAYMENT_STATUS_CONFIRMED = 3;
export const PAYMENT_STATUS_FAILED = 6;
export const PAYMENT_STATUS_PENDING = 7;
export const PAYMENT_STATUS_UNKNOWN = 9;
